import { Label } from '@src/design-system/label';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { ErrorMessage, useField } from 'formik';
import {
  Textarea,
  TextareaCharacterDisplay,
  TextareaInput,
} from '@src/design-system/textarea';
import type { ComponentProps } from 'react';

export function TextAreafield({
  label,
  name,
  labelProps,
  withMaxLength = true,
  ...props
}: {
  label: string;
  name: string;
  withMaxLength?: boolean;
  labelProps?: ComponentProps<typeof Label>;
} & ComponentProps<typeof TextareaInput>) {
  const [fieldProps, fieldMeta] = useField(name);

  const labelEl = (
    <Label
      htmlFor={name}
      {...labelProps}
    >
      {label}
    </Label>
  );

  return (
    <Textarea maxLength={withMaxLength ? 1000 : undefined}>
      {withMaxLength ? (
        <div className='flex justify-between'>
          {label && labelEl}
          <TextareaCharacterDisplay />
        </div>
      ) : (
        label && labelEl
      )}
      <TextareaInput
        hasError={!!fieldMeta.error && fieldMeta.touched}
        id={name}
        placeholder='Write text here...'
        {...fieldProps}
        {...props}
      />
      <ErrorMessage
        name={name}
        component={CustomErrorMessage}
      />
    </Textarea>
  );
}
